import styles from "./LeadershipTeam.module.css";
import Image from "next/image";
interface Image {
  id: number;
  documentId: string;
  url: string;
  alternativeText: string;
}
interface TileDescription {
  id: number;
  title: string;
  description: string;
}
interface PersonTile {
  id: number;
  title_description: TileDescription;
  images: Image[];
}
interface LeadershipTeam {
  id: number;
  title: string;
  cards: PersonTile[];
}
interface Props {
  data: LeadershipTeam;
}

const LeadershipTeam: React.FC<Props> = ({ data }) => {
  const { title, cards } = data;
  return (
    <div className={` ${styles.leadershipContainer}`}>
      <div className="container">
        <h2 className={styles.title}>{title}</h2>
        <div className="row">
          {cards?.map((item, index) => (
            <div key={index} className="col-sm-6 col-md-4  text-center">
              <div className={styles.leaderCard}>
                <div className={styles.teamImage}>
                  <Image
                    src={item?.images[0]?.url}
                    alt={item?.images[0]?.alternativeText || "Leadership Team"}
                    title={
                      item?.images[0]?.alternativeText || "Leadership Team"
                    }
                    width={200}
                    height={164}
                    className={styles.leaderImage}
                    priority
                  />
                </div>
                <div className={styles.teamDetails}>
                  <h3 className={styles.leaderName}>
                    {item?.title_description?.title}
                  </h3>
                  <p className={styles.leaderDesignation}>
                    {item?.title_description?.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LeadershipTeam;
